export default __webpack_public_path__ + "static/media/loading-logo.9672101c.svg";